module.exports = __webpack_public_path__ + "img/subBanner4.b1b41a78.png";